import './MisionVision.css';

const cards = [
  {
    id: 'mision',
    icon: '🎯',
    titulo: 'Misión',
    texto:
      'Brindamos servicios de transporte de carga pesada con seguridad, eficiencia y compromiso, superando las expectativas de nuestros clientes y contribuyendo al desarrollo del país.',
  },
  {
    id: 'vision',
    icon: '👁️',
    titulo: 'Visión',
    texto:
      'Ser la empresa de transporte terrestre de carga pesada más confiable y reconocida del Perú, líder en calidad de servicio, seguridad y responsabilidad.',
  },
  {
    id: 'proposito',
    icon: '🤝',
    titulo: 'Propósito',
    texto:
      'Conectar oportunamente las necesidades a las distintas industrias que transportan mercancía, generando valor para nuestros clientes.',
  },
];

export default function MisionVision() {
  return (
    <section id="nosotros" className="mision-vision">
      <div className="container">
        <h2 className="section-title">Quiénes Somos</h2>
        <div className="section-divider" />
        <div className="mv__grid">
          {cards.map((card) => (
            <div key={card.id} className="mv__card">
              <div className="mv__icon">{card.icon}</div>
              <h3 className="mv__card-title">{card.titulo}</h3>
              <p className="mv__card-text">{card.texto}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
